import type { OcLineComparisonFlagFieldId } from '@/types/orderConfirmationSettings'

export interface OcLineComparisonField {
  id: OcLineComparisonFlagFieldId
  label: string
}

export const OC_LINE_COMPARISON_FIELDS: OcLineComparisonField[] = [
  { id: 'flag_supplier_article_number', label: 'Supplier article number' },
  { id: 'flag_article_revision_number', label: 'Article revision number' },
  { id: 'flag_article_drawing_number', label: 'Article drawing number' },
]
